import React, { Component } from 'react';
import { Table, Row, Button, Modal, message, Input, Spin, Col, Divider, Tree, Select, Popconfirm } from 'antd';
import './index.scss';

const TreeNode = Tree.TreeNode;
const Option = Select.Option;

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            visible: false,
            loading: true,
            loadingSave: false,
            editname: '',
            thisId: '',
            searchname: '',
            dataTotal: []
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        fetch('/typelst', { credentials: 'include' }).then(x => x.json()).then(x => {
            this.setState({ loading: false });
            if (x.status == 1) {
                this.setState({
                    data: x.data || [],
                    dataTotal: x.data || [],
                });
                console.log(x.data)
                return
            }
            message.error('数据获取失败！' + JSON.stringify(x.msg))
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
            message.error('数据获取失败！' + JSON.stringify(err))
        })
    }

    onChange = (value, lable, extra) => {
        this.setState({});
    }

    handleOk = (e) => {
        this.setState({ loadingSave: true });
        let name = this.state.editname;
        let id = this.state.thisId;
        let dataFrom = new FormData();
        dataFrom.append('name', name);
        !id ? '' : dataFrom.append('id', id)
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch(`/actionType`, headres).then(x => x.json()).then(x => {
            if (x.status == 1) {
                message.info('保存成功！');
                this.getData();
                this.setState({
                    visible: false,
                    loadingSave: false,
                    loading: true,
                });
                return
            }
            message.error(x.msg);
            this.setState({
                loadingSave: false
            });

        }).catch(err => {
            console.error(err);
            message.error('数据添加失败！')
            this.setState({
                loadingSave: false
            });
        })
    }

    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    }

    delType = (id) => {
        fetch(`/deleteType?id=${id}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.status == 1) {
                message.info('删除成功！');
                this.getData()
                return
            }
            message.error(x.msg);
        }).catch(err => {
            console.error(err);
            message.error('数据删除失败！')
        })
    }

    render() {
        const columns = [{
            title: '序号',
            dataIndex: 'id',
            key: 'id',
        }, {
            title: '标签名称',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: '操作',
            key: 'action',
            render: (record) => {
                return (
                    <div>
                        <span
                            style={{ color: "#1890ff", cursor: "pointer" }}
                            onClick={() => {
                                this.setState({
                                    thisId: record.id,
                                    editname: record.name
                                }, this.showModal)
                            }}
                        >编辑</span>
                        <Divider type="vertical" />
                        <Popconfirm
                            title="确定要删除吗?"
                            onConfirm={() => { this.delType(record.id) }}
                            okText="确定"
                            cancelText="取消"
                        >
                            <span
                                style={{ color: "#1890ff", cursor: "pointer" }}
                            >删除</span>
                        </Popconfirm>

                    </div>
                )
            }
        }];
        const data = this.state.data;

        return (
            <div className='settings'>
                <Row style={{ margin: '20px 0' }}>
                    <Col span={12}>
                        <span>名称：</span>
                        <Input
                            style={{ width: 200, marginRight: 10 }}
                            value={this.state.searchname}
                            onChange={(e) => {
                                this.setState({
                                    searchname: e.target.value
                                });
                            }}
                        />
                        <Button
                            type="primary"
                            onClick={() => {
                                let newdata = (this.state.dataTotal || []).filter(item => (item.name || "").includes(this.state.searchname));
                                this.setState({ data: newdata });
                            }}
                        >搜索</Button>
                    </Col>
                    <Col span={12}>
                        <Row type="flex" justify="end">
                            <Button
                                type="primary"
                                onClick={() => {
                                    this.setState({
                                        thisId: '',
                                        editname: ''
                                    }, this.showModal)
                                }}
                                style={{ marginRight: 10 }}
                            >新增</Button>
                        </Row>
                    </Col>
                </Row>

                <Spin spinning={this.state.loading}>
                    <Table
                        style={{ marginTop: 20 }}
                        columns={columns}
                        dataSource={data}
                        bordered
                        rowKey={(item, index) => index}
                    />
                </Spin>
                <Row style={{ textAlign: "right", marginTop: 20 }}>
                    <Button
                        key="submit"
                        type="primary"
                        onClick={() => {
                            this.props.history.goBack();
                        }}
                    >
                        返回
                    </Button>
                </Row>
                <Modal
                    title={!this.state.thisId ? "标签添加" : "编辑标签"}
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>取消</Button>,
                        <Button key="submit" type="primary" loading={this.state.loadingSave} onClick={this.handleOk}>
                            保存
                        </Button>,
                    ]}
                >
                    <Row className="modal">
                        <Row>
                            <span>标签名称：</span>
                            <Input
                                placeholder="请输入标签名称"
                                style={{ width: '60%', marginLeft: 10 }}
                                value={this.state.editname}
                                onChange={(e) => {
                                    this.setState({
                                        editname: e.target.value || ""
                                    })
                                }}
                            />
                        </Row>
                    </Row>
                </Modal>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/setting/LabelManagement.js